import React from "react";
import style from './Controls.scss'

import {connect} from 'react-redux'
import FieldController from './components/Field-controller'
import {fieldTypes} from './schema'
import {DragDropContext, Droppable, Draggable} from "react-beautiful-dnd";


class Controls extends React.Component {


    render() {

        return (
            <div className={style.wraper+ ' ' + style.bgWhite}>

                    <Droppable droppableId="fields" type="column" isDropDisabled={true}>
                        {(provided, snapshot) => (
                            <div {...provided.droppableProps}
                                 ref={provided.innerRef}
                               >
                                {
                                    fieldTypes.map((group,index) => {
                                        return group.fields.map((e,i)=>{
                                            return (<FieldController key={e.key}  index={i} field={e}/>);
                                        })
                                    })
                                }
                            </div>
                        )}
                    </Droppable>

            </div>
        )
    }
}


export default Controls
